import { browserTracingIntegration, init } from '@sentry/vue';
import type { Plugin } from 'vue';

import { getDomain } from '@libs/utils';

import router from '../router/routerSetup';

const HIGH_SAMPLER_RATE = 0.1;
const DEFAULT_SAMPLER_RATE = 0.01;

export function createLogger(): Plugin {
  return {
    install(app): void {
      if (getDomain.isProduction) {
        init({
          app,
          dsn: 'https://a325fb177cba4b8394fd1302d9a33c15@o4505316832051200.ingest.sentry.io/4505403376599040',
          enabled: getDomain.isProduction,
          ignoreErrors: [
            'ResizeObserver loop completed with undelivered notifications', // NOTE: Benign browser noise; observer couldn't deliver all notifications within a single frame, no user impact.
            'ResizeObserver loop limit exceeded', // NOTE: Benign browser noise; same ResizeObserver delivery limitation, no user impact.
            'Product card image failed loading from',
            'Network Error',
            'Failed to fetch', // NOTE: No HTTP response reached the client (transient network / in-app WebView / ad-blocker / consent gate). Real backend errors surface as 'Request failed with status N' and are kept; a total outage would also appear here but is covered by backend/uptime monitoring.
            'Request failed with status code 404',
            'Failed to fetch IP position from: https://ipapi.co/json/!', // NOTE: Third-party geo-IP lookup (ipapi.co) failing; non-critical, app works without it.
            '_AutofillCallbackHandler', // NOTE: Common error in Meta built-in browser for iOS that does not affect user experience: https://developers.facebook.com/community/threads/320013549791141/
            'Endpoint: /d/mvc/Members/GetMember', // NOTE: Member session check returns 401 when the user is not logged in; expected and handled.
            'ReactNativeHistoryShim', // NOTE: Injected by the native app's WKWebView history shim, not our code; throws when the message handler is absent.
            'Error invoking postMessage: Java object is gone', // NOTE: Facebook in-app browser's injected nav perf logger posting to a native bridge that was already torn down; not our code, no user impact.
          ],
          integrations: [
            browserTracingIntegration({
              router,
            }),
          ],
          tracesSampleRate: DEFAULT_SAMPLER_RATE,
          sampleRate: 1,
          tracesSampler: ({ attributes }) =>
            attributes?.['sentry.op'] !== 'pageload'
              ? HIGH_SAMPLER_RATE
              : DEFAULT_SAMPLER_RATE,
        });
      }
    },
  };
}
